import React, { Fragment, useEffect, useState } from 'react';
import FormSection from 'components/sales/formSection/formSectionNew';
import localization from 'assets/localization/localization';
// import Regex from 'services/utils/regex/Regex';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import { FormGroup } from 'react-bootstrap';
import TimePicker from 'react-times';
import 'react-times/css/classic/default.css';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import { DatePickerInput } from 'rc-datepicker';
// import DatePicker from 'components/sales/datePicker/datePicker';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import './carnival.css';
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
// import ReactTooltip from "react-tooltip";
import { handleValidateObj } from 'constants/objValues/objvalues';
import SearchLocation from 'components/sales/searchLocation/searchLocation';
import { useParams } from 'react-router-dom';

const CarnivalForm = ({
  handleValue,
//   siteId,
  leadInfraId,
  documentUploadUrl,
  documentUrlData,
  getLeadInfraId,
  prefilledData,
  match
}) => {
    const inputs = {
        services: '',
        start_date: '',
        start_time: `${new Date().getHours()}:${new Date().getMinutes()}`,
        end_date: '',
        end_time: `${new Date().getHours()}:${new Date().getMinutes()}`,
        // subject: '',
        members: '',
        // id: '',
        rwa_members: '',
        rwaImage: '',
        services_data: '',
        event_status : '',
        total_footfall : '',
        site_id: '',
        event_photo : '',
        gst_number : '',
        cancelled_cheque : '',
        bank_name : '',
        act_number : '',
        ifsc_code: '',
        branch_name: '',
        carnival_type: '',
        total_tags_issued:'',
        manpower_required:'',
        partner_allowed:'',
        location:'',
        lat:'',
        lng:'',
        remarks:'',
        residents_tags_charge:'',
        is_gst_available:'',
        charge_reason: ''
    };
    const [inputList, setInputList] = useState([{ name:"",image_url: "", position: ""}]);
    const [formData, setData] = useState(inputs);
    const [infraId, setInfraId] = useState(0);
    const [projectName, setProjectName] = useState();
    const [infraIdToCheck, setInfraIdToCheck] = useState();
    const [services, setServices] = useState();
    // const [rwaMember, setRwaMember] = useState();
    const [minDateIndex, setMinDateIndex] = useState(null);
    const [addMembers, setAddMembers] = useState(0);
    const [isEditForm, setIsEditForm] = useState(false);
    // const [rwaImage, setRwaImage] = useState();
    const [isEnable, setIsEnable] = useState(true);
    const [carnivalType, setCarnivalType]=useState('carnival');

    const [optOption, setOptOption] = useState({
      address2: '',
      currentLocation: '',
    });
    const [isInputError, setIsInputError] = useState({
      latError: false,
      longError: false,
      pinError: false,
      crl: false,
      isPinNotFound: false,
    });
    const[selectedLocation,setSelectedLocation]=useState(null);

    const { siteId } = useParams();
    localStorage.setItem('siteId', siteId);

    useEffect(() => {
        if (!formData.partners || formData.partners.length === 0) {
          setData({
            ...formData,
            partners: [{ companyName: '', cost: '' }],
          });
        }
      }, [formData, setData]);

    useEffect(() => {
        if(match?.params?.carnival_type!=undefined && match?.params?.carnival_type!=null){
            if(match?.params?.carnival_type=='helpdesk'){
                setCarnivalType('Helpdesk')
            }else{
                setCarnivalType('Carnival')
            }
        }else{
            setCarnivalType('Carnival')
        }

    }, [match?.params?.carnival_type]);
    useEffect(() => {
        if (leadInfraId?.status == 1 && leadInfraId.infra_project_id == infraIdToCheck) {
            if (leadInfraId?.infra_project_id) {
                setInfraId(leadInfraId?.infra_project_id);
                setProjectName(leadInfraId?.project_name);
                handleCurrentLocationChange(leadInfraId?.city);
                setSelectedLocation(leadInfraId?.city);
                setData({
                    ...formData,
                    subject: leadInfraId?.project_name,
                    gst_number: leadInfraId?.gst,
                    lat: leadInfraId?.latitude,
                    lng: leadInfraId?.longitude
                  });
            }
            if (leadInfraId?.services) {
                setServices(leadInfraId.services);
            }
        } 
        if(leadInfraId?.status == 0 && infraIdToCheck !== null) {
            // console.log('rete');
            toast.error('Project Id not found.');
            setInfraId(0);
        }
    }, [leadInfraId]);

    const handleStartDate = (date, dateString) => {
        setData({ ...formData, start_date: dateString });
        setMinDateIndex(dateString);
    };

    const handleEndDate = (date, dateString) => {
        setData({ ...formData, end_date: dateString });
    };

    useEffect(() => {
        if (prefilledData?.carnival !== null && prefilledData?.carnival !== undefined) {
            const {
                id,
                infra_id,
                name,
                start_date,
                start_time,
                end_date,
                end_time,
                services,
                city,
                latitude,
                longitude,
                // members,
                project_name,
                // member_exists
                event_status,
                total_footfall,
                event_photo,
                bank_name,
                branch_name,
                ifsc_code,
                act_number,
                gst,
                cancelled_cheque,
                total_tags_issued,
                manpower_required,
                partner_allowed,
                location_data,
                remarks
            } = prefilledData?.carnival;
                checkInfraId(infra_id);
                setInfraIdToCheck(infra_id);
                setInfraId(infra_id);
                setProjectName(project_name);
                handleCurrentLocationChange(city);
                setSelectedLocation(city);
                setData({ ...formData, lat: latitude, lng:longitude });
                if(gst != ''){
                    setData({ ...formData, gst_number: gst});
                }
                setIsEditForm(true);
                setData({ ...formData,
                    isEdit: 1,
                    services: services,
                    start_date: start_date,
                    end_date: end_date,
                    start_time: start_time,
                    end_time: end_time,
                    carnival_id: id
                });
            
        }
    }, [prefilledData])

  const handleMeetingData = () => {
    if (
        // formData.services?.length > 0 &&
        formData.start_date !== '' &&
        formData.end_date !== '' &&
        formData.start_time !== '' &&
        formData.end_time !== '' &&
        formData.subject !== ''
    ) {
        handleValue({ ...formData, members: inputList, infra_id: infraId });
    } else handleValue(null);
  };
  useEffect(() => {
    handleMeetingData();
  }, [formData, inputList]);

    useEffect(() => {
        if(selectedLocation!=null||selectedLocation!=''||selectedLocation!=undefined){
            setData({...formData,location:selectedLocation});
        }
    }, [formData.lat, formData.lng]);

    function onStartChange(value) {
        const { hour, minute } = value;
        setData({ ...formData, start_time: `${hour}:${minute}` });
    }
    function onEndChange(value) {
        const { hour, minute } = value;
        setData({ ...formData, end_time: `${hour}:${minute}` });
    }

    // handle input change
    const handleInputChange = (e, index, type) => {
        const { name, value } = e.target;
        const list = [...inputList];
        list[index][type] = value;
        setInputList(list);
    };
    const saveImage = (val, index=null) => {
        if (index != null) {
            const list = [...inputList];
            list[index]["image_url"] = val;
            setInputList(list);
        } else {
            if (prefilledData?.carnival.member_exists == 2) {
                setData({ ...formData, rwaImage: prefilledData?.carnival.members });
            } else {
                setData({ ...formData, rwaImage: val });
            }
        }
    };
    const handlePriceChange = (val, index) => {
        const list2 = formData.services;
        list2[index]["price"] = val;
        setData({
            ...formData,
            services: list2,
        })
    };
    
    useEffect(() => { 
       if(match?.params?.infra_id !== undefined) {
        setInfraId(match?.params?.infra_id);
        (async () => {
            let res = await getLeadInfraId(match.params.infra_id, siteId);
            if (res) { console.log(JSON.stringify(res));
                if (res?.infra_project_id) {
                    setInfraId(res?.infra_project_id);
                    setProjectName(res?.project_name);
                    handleCurrentLocationChange(res?.city);
                    setSelectedLocation(res?.city);
                    setData({
                        ...formData,
                        subject: res?.project_name,
                        gst_number: res?.gst,
                        site_id: siteId,
                        lat: res?.latitude,
                        lng: res?.longitude
                      });
                }
                if (res?.services) {
                    setServices(res.services);
                } 
            }
          })();
       }
    },[match.params.infra_id]);

    const handlePartnerChange = (index, field, value) => {
        const updatedPartners = [...formData.partners];
        updatedPartners[index][field] = value;
        setData({ ...formData, partners: updatedPartners });
      };
    
      const addPartner = () => {
        setData({
          ...formData,
          partners: [...formData.partners, { companyName: '', cost: '' }],
        });
      };
    
      const removePartner = (index) => {
        if (formData.partners.length > 1) {
          const updatedPartners = [...formData.partners];
          updatedPartners.splice(index, 1);
          setData({ ...formData, partners: updatedPartners });
        }
      };

    const handleCurrentLocationBlur = (latlng = null) => {
        if (latlng !== null && latlng !== undefined) {
          const { lat, lng } = latlng;
          console.log(latlng);
          setData({ ...formData, lat: lat, lng: lng, location:selectedLocation  });
          setIsEnable(true);
        }
        if (latlng === null) {
          setIsEnable(false);
          // setlocationData({ ...locationData, isLat: "", isLong: "" });
        }
    };

    const handleCurrentLocationChange = (value) => {
        setOptOption({ ...optOption, currentLocation: value });
        localStorage.setItem('currentLocation', value);
    };
    
    const checkInfraId = (infra_id) => {
        (async () => {
              let res = await getLeadInfraId(((infraIdToCheck !== undefined) ? infraIdToCheck : infra_id), siteId);
              if (res?.resultSets) {
              }
            })();
    };
    const calculateServices = () => {
      // console.log(formData.services);
        if (formData.services?.length > 0) {
            return (
                
                formData.services.map((x, i) => {
                    return (
                    <>
                    <div className="row">
                        {/* <div className="col-md-1 col-sm-12"></div> */}
                        <div className="col-md-5  col-sm-12">
                        <ConstantInput
                            label={localization.serviceName}
                            value={x.name}
                            disabled
                        />
                        </div>
                      { x.id == 1 || x.id == 2 ?
                        <div className="col-md-5  col-sm-12">
                          <ConstantInput
                              type="text"
                              errorMsg={localization.requiredPromo}
                              label={localization.promocode}
                              required
                              isStarRequired={true}
                              // max={500}
                              // handleChange={(val) =>
                              //     setData({
                              //         ...formData,
                              //         prices: val,
                              //     })
                              // }
                              handleChange={e => handlePriceChange(e, i)}
                              value = {x?.price}
                              disabled = {isEditForm}
                              // regex={Regex.numericNotZero.test(formData.quantity)}
                          />
                        </div>
                          : null
                      }

                        {/*{ i==0 ?
                            <div className="col-md-2 col-sm-12">
                                <button className="btn btn-sm btn-primary" data-tip data-for="registerTip">
                                    Suggestion
                                </button>

                                <ReactTooltip id="registerTip" place="left" type="info">
                                    - Sum of price should not exceed 1000.
                                    <br/>- For 2 services, price can 500 for both of them.
                                    <br/>- For 3 services, price can be 200, 300 & 500.
                                </ReactTooltip>
                            </div>
                        
                        : null}*/}
                    </div>
                    <hr/>
                    </>
                );
            })
            );
        }
    };

    // console.log("FORM DATA: ", formData)

    /*const handleMemberChange = (val) => {
        setAddMembers(val.id);
        setData({ ...formData, rwa_members: val.id })
    };*/
  return (
    <FormSection title={'Carnival/Helpdesk Details'}>
        <div className="row">
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                    label={localization.projectId}
                    value={infraId !== 0 ? infraId : null}
                    handleChange={(value) => setInfraIdToCheck(value)}
                    disabled={formData?.isEdit || infraId}
                    // disabled={true}
                />
            </div>
            {/* <div className="col-md-2 col-sm-5">
                <button className="btn btn-sm btn-primary" onClick={checkInfraId}>Check</button>
            </div> */}
        </div>
        
        {/* {infraId !== 0 ? ( */}
        <>
        <div className="row form-group">
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                    label={localization.projectName}
                    value={projectName}
                    disabled={formData?.isEdit || infraId}
                />
            </div>
            {/*<div className="col-md-6 col-sm-12">
                <ConstantInput
                    value={formData.subject}
                    label={localization.societyName}
                    errorMsg={localization.enterSocietyName}
                    type="text"
                    maxLength={20}
                    required
                    handleChange={(value) => setData({ ...formData, subject: value })}
                    isStarRequired={true}
                    fullWidth
                />
            </div>*/}
        </div>
          <div className="row form-group">
            <div className="col-md-6 col-sm-12">
                <FormGroup
                    className={`date custom_date_picker active-date`}
                >
                    <DatePickerInput
                    value={formData?.start_date ? new Date(formData?.start_date) : null}
                    onChange={handleStartDate}
                    autoClose
                    closeOnClickOutside
                    showOnInputClick
                    locale="en"
                    className="my-custom-datepicker-component"
                    required
                    displayFormat="DD-MM-YYYY"
                    returnFormat="YYYY-MM-DD"
                    minDate={new Date()}
                    // value={formData?.start_date}
                    />
                    <label>
                    {localization.startDate}{' '}
                    <span className="label-star" style={{ color: 'red' }}>
                        {' '}
                        *{' '}
                    </span>
                    </label>
                
                </FormGroup>
            </div>
            <div className="col-md-6 col-sm-12">
                <FormGroup>
                    <TimePicker
                    theme="classic"
                    timeFormat="HH:MM"
                    timeMode={24}
                    time={formData?.start_time}
                    onTimeChange={onStartChange}
                    />
                    <label>{localization.startTime}{' '}
                    <span className="label-star" style={{ color: 'red' }}>
                        {' '}
                        *{' '}
                    </span></label>
                    <label className="error date_error">{localization.isRequired}</label>
                </FormGroup>
            </div>
            <div className="col-md-6 col-sm-12">
                <FormGroup
                    className={`date custom_date_picker active-date`}
                >
                    <DatePickerInput
                    value={formData?.end_date ? new Date(formData?.end_date) : null}
                    onChange={handleEndDate}
                    autoClose
                    closeOnClickOutside
                    showOnInputClick
                    locale="en"
                    className="my-custom-datepicker-component"
                    required
                    displayFormat="DD-MM-YYYY"
                    returnFormat="YYYY-MM-DD"
                    minDate={minDateIndex === null 
                        ? new Date()
                        : minDateIndex}
                    />
                    <label>
                    {localization.endDate}{' '}
                    <span className="label-star" style={{ color: 'red' }}>
                        {' '}
                        *{' '}
                    </span>
                    </label>
                
                </FormGroup>
            </div>
            <div className="col-md-6 col-sm-12">
                <FormGroup>
                    <TimePicker
                    theme="classic"
                    timeFormat="HH:MM"
                    timeMode={24}
                    time={formData?.end_time}
                    onTimeChange={onEndChange}
                    />
                    <label>{localization.endTime}{' '}
                    <span className="label-star" style={{ color: 'red' }}>
                        {' '}
                        *{' '}
                    </span></label>
                    <label className="error date_error">{localization.isRequired}</label>
                </FormGroup>
            </div>
            <div className="col-md-6">
                <DropDownInput
                    data={[
                        {
                            "id":"Yes",
                            "name":"Yes"
                        },
                        {
                            "id":"No",
                            "name":"No"
                        }
                    ]}
                    label={'Do/Will you charge the residents for tags in your society?'}
                    required
                    errorMsg={'This is required'}
                    getIdValue={(val) => {
                        setData({
                            ...formData,
                            residents_tags_charge: val.id,
                        });
                    }}
                    isStarRequired={true}
                    // value={isEditForm ? formData?.residents_tags_charge : ''}        
                />
            </div>

            {formData?.residents_tags_charge == 'Yes' && (
                <div className="col-md-6">
                    <DropDownInput
                        data={[
                            {
                                "id":"Add tag price to maintenance bill",
                                "name":"Add tag price to maintenance bill"
                            },
                            {
                                "id":"Cash/Online while issuing tag",
                                "name":"Cash/Online while issuing tag"
                            }
                        ]}
                        label={'How do you charge them?'}
                        required
                        errorMsg={'This is required'}
                        getIdValue={(val) => {
                            setData({
                                ...formData,
                                charge_reason: val.id,
                            });
                        }}
                        isStarRequired={true}
                        // value={isEditForm ? formData?.residents_tags_charge : ''}        
                    />
                </div>
            )}
        </div>


        {/* <FormSection title={localization.serviceDetails}>
            <div className="form-group">
                    <DropDownInput
                        multipule
                        // selectedList={pocsList.length > 0 ? pocsList : []}
                        data={services}
                        label={localization.services}
                        required
                        errorMsg={localization.requiredServices}
                        getIdValue={(val) => {
                        const list = val;
                        setData({
                            ...formData,
                            services: list,
                        });
                        }}
                        isStarRequired={true}
                        selectedList={isEditForm ? formData?.services : []}
                        disabled = {isEditForm}
                    />
            </div>
            <>
            {formData.services?.length > 0 ?
                (calculateServices())
                :null
            }
            </>
        </FormSection> */}

        <div className="col-md-6">
            <DropDownInput
                data={[
                    {
                        "id":"CARNIVAL",
                        "name":"Carnival"
                    },
                    {
                        "id":"HELPDESK",
                        "name":"Helpdesk"
                    }
                ]}
                label={'Select Type'}
                required
                errorMsg={'This is required'}
                getIdValue={(val) => {
                    setCarnivalType(val?.value)
                    setData({
                        ...formData,
                        carnival_type: val?.value,
                    });
                }}
                isStarRequired={true}    
            />
        </div>

        {leadInfraId?.gst=='' && 
            <div className="col-md-6">
                <DropDownInput
                    data={[
                        {
                            "id":"Yes",
                            "name":"Yes"
                        },
                        {
                            "id":"No",
                            "name":"No"
                        }
                    ]}
                    label={'Do you have GST?'}
                    required
                    errorMsg={'This is required'}
                    getIdValue={(val) => {
                        setData({
                            ...formData,
                            is_gst_available: val.id,
                        });
                    }}
                    isStarRequired={true}      
                />
            </div>
        }

        {(formData?.is_gst_available == 'Yes' || leadInfraId?.gst!='') && (
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                    label={'Gst Number'}
                    type={'text'}
                    value={isEditForm ? leadInfraId?.gst : leadInfraId?.gst}
                    handleChange={(value) => setData({
                        ...formData,
                        gst_number: value,
                    })}
                    disabled={formData?.isEdit || leadInfraId?.gst}
                />
            </div>
            )
        }

        <div className="col-sm-6">
            <FileUpload
                id={`photoUpload`}
                accept=".png,.jpg,.jpeg"
                documentUploadUrl={documentUploadUrl}
                documentUrlData={documentUrlData}
                value={isEditForm ? formData?.event_photo : ''}
                onChange={(value) => setData({
                    ...formData,
                    event_photo: value,
                })}
            >
                <span className="btn btn-transparent">Upload event place photo</span>
            </FileUpload>
        </div>

        <div className="col-sm-6">
            <FileUpload
                id={`chequeUpload`}
                accept=".png,.jpg,.jpeg,.pdf"
                documentUploadUrl={documentUploadUrl}
                documentUrlData={documentUrlData}
                value={isEditForm ? formData?.cancelled_cheque : ''}
                onChange={(value) => setData({
                    ...formData,
                    cancelled_cheque: value,
                })}
            >
                <span className="btn btn-transparent">Upload Cancelled Cheque</span>
            </FileUpload>
        </div>

        <FormSection title="Bank Details">
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                label={'Bank Name'}
                type={'text'}
                value={isEditForm ? formData?.bank_name : ''}
                handleChange={(value) => setData({
                    ...formData,
                    bank_name: value,
                })}
                disabled={formData?.isEdit}
                />
            </div>

            <div className="col-md-6 col-sm-12">
                <ConstantInput
                label={'Account Number'}
                type={'number'}
                value={isEditForm ? formData?.act_number : ''}
                handleChange={(value) => setData({
                    ...formData,
                    act_number: value,
                })}
                disabled={formData?.isEdit}
                />
            </div>

            <div className="col-md-6 col-sm-12">
                <ConstantInput
                label={'IFSC Code'}
                type={'text'}
                value={isEditForm ? formData?.ifsc_code : ''}
                handleChange={(value) => setData({
                    ...formData,
                    ifsc_code: value,
                })}
                disabled={formData?.isEdit}
                />
            </div>

            <div className="col-md-6 col-sm-12">
                <ConstantInput
                label={'Branch Name of the bank'}
                type={'text'}
                value={isEditForm ? formData?.branch_name : ''}
                handleChange={(value) => setData({
                    ...formData,
                    branch_name: value,
                })}
                disabled={formData?.isEdit}
                />
            </div>
        </FormSection>

        <FormSection title="Partner Details">
        {(formData.partners || []).map((partner, index) => (
            <div key={index} className="row mb-3 border p-2">
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                label="Name of the Company"
                type="text"
                // isStarRequired={true}
                value={partner.companyName}
                handleChange={(value) => handlePartnerChange(index, 'companyName', value)}
                disabled={formData?.isEdit}
                />
            </div>

            <div className="col-md-6 col-sm-12">
                <ConstantInput
                label="Cost of Partner"
                type="number"
                // isStarRequired={true}
                value={partner.cost}
                handleChange={(value) => handlePartnerChange(index, 'cost', value)}
                disabled={formData?.isEdit}
                />
            </div>

            {formData.partners.length > 1 && (
                <div className="col-md-12 mt-2">
                <button
                    type="button"
                    className="btn btn-danger btn-sm me-2"
                    onClick={() => removePartner(index)}
                    disabled={formData?.isEdit}
                >
                    Remove
                </button>
                </div>
            )}
            </div>
        ))}

        <div className="col-md-12">
            <button
            type="button"
            className="btn btn-sm btn-primary me-2"
            onClick={addPartner}
            disabled={formData?.isEdit}
            >
            Add Partner
            </button>
        </div>
        </FormSection>

        <FormSection title={localization.eventDetails}>
            <div className="col-md-6 col-sm-12">
                <DropDownInput
                    data={[
                        {
                            "id":"Confirmed",
                            "name":"Confirmed"
                        },
                        {
                            "id":"Tentative",
                            "name":"Tentative"
                        }
                    ]}
                    label={localization.eventStatus}
                    required
                    errorMsg={localization.requiredEventStatus}
                    getIdValue={(val) => {
                    const list = val;
                    setData({
                        ...formData,
                        event_status: val.id,
                    });
                    }}
                    isStarRequired={true}
                    value={isEditForm ? formData?.event_status : ''}
                    disabled = {isEditForm}
                />
            </div>
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                            label={'Total footfall'}
                            type={'number'}
                            value={isEditForm ? formData?.total_footfall : ''}
                            handleChange={(value) => setData({
                                ...formData,
                                total_footfall: value,
                            })}
                            disabled={formData?.isEdit}
                            isStarRequired={true}
                        />
            </div>
            {/* <div className="col-md-6 col-sm-12">
                <ConstantInput
                            label={'Total Tags Issued'}
                            type={'number'}
                            value={isEditForm ? formData?.total_tags_issued : ''}
                            handleChange={(value) => setData({
                                ...formData,
                                total_tags_issued: value,
                            })}
                            disabled={formData?.isEdit}
                            isStarRequired={true}
                        />
            </div> */}
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                            label={'Manpower required'}
                            type={'number'}
                            value={isEditForm ? formData?.manpower_required : ''}
                            handleChange={(value) => setData({
                                ...formData,
                                manpower_required: value,
                            })}
                            disabled={formData?.isEdit}
                            isStarRequired={true}
                        />
            </div>
            {/* <div className="col-md-6 col-sm-12">
                <DropDownInput
                    data={[
                        {
                            "id":"Yes",
                            "name":"Yes"
                        },
                        {
                            "id":"No",
                            "name":"No"
                        }
                    ]}
                    label={'Partner allowed'}
                    required
                    errorMsg={'Partner allowed is required'}
                    getIdValue={(val) => {
                        setData({
                            ...formData,
                            partner_allowed: val.id,
                        });
                    }}
                    isStarRequired={true}
                    value={isEditForm ? formData?.partner_allowed : ''}
                    disabled = {isEditForm}
                />
            </div> */}
            <div className="col-md-6 col-sm-12">
                <SearchLocation
                    handleCurrentLocationBlur={handleCurrentLocationBlur}
                    isError={isInputError.crl}
                    value={optOption.currentLocation}
                    handleCurrentLocationChange={handleCurrentLocationChange}
                    setSelectedLocation={setSelectedLocation}
                />
            </div>
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                    label={'Latitude'}
                    type={'number'}
                    value={formData?.lat}
                    disabled={true}
                />
            </div>
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                    label={'Longitude'}
                    type={'number'}
                    value={formData?.lng}
                    disabled={true}
                />
            </div>
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                            label={'Remarks'}
                            type={'text'}
                            value={isEditForm ? formData?.remarks : ''}
                            handleChange={(value) => setData({
                                ...formData,
                                remarks: value,
                            })}
                            disabled={formData?.isEdit}
                        />
            </div>
        </FormSection>
          {/*<FormSection title={localization.memberDetails}>
            <div className="row form-group">
                <div className="col-md-3 col-sm-12">
                    <DropDownInput
                        data={[
                            { name: 'Yes', id: 1 },
                            { name: 'No', id: 2 }
                        ]}
                        label={localization.addMembers}
                        required={true}
                        isStarRequired={true}
                        errorMsg={localization.isRequired}
                        getIdValue={(val) => handleMemberChange(val)}
                        value={rwaMember}
                    />
                </div>
            </div>
            {addMembers === 1 ? (
                <>
                {inputList.map((x, i) => {
                return (
                    <div className="row form-group">
                        <div className="col-md-4 col-sm-12">
                            <input
                                type="text"
                                className="form-control"
                                name="member_name"
                                placeholder="Member name"
                                onChange={e => handleInputChange(e, i, "name")}
                                required={true}
                                value={x?.name}
                            />
                        </div>
                        
                        <div className="col-md-4 col-sm-12">
                            <input
                                className="form-control"
                                name="designation"
                                placeholder="Designation"
                                onChange={e => handleInputChange(e, i, "position")}
                                required={true}
                                value={x?.position}
                            />
                        </div>
                        <div className="col-md-2 col-sm-12">
                            <FileUpload
                                id={"addAttachment" + i}
                                accept=".pdf,.png,.jpg,.jpeg,.doc"
                                documentUploadUrl={documentUploadUrl}
                                documentUrlData={documentUrlData}
                                onChange={(val) =>
                                    saveImage(val, i)
                                }
                                prefilledFilename={x?.image_url}
                                // value={x?.image_url}
                                >
                                <span className="btn btn-transparent">
                                    {localization.image}
                                </span>
                            </FileUpload>
                        </div>

                         <div className="btn-box">
                            {inputList.length !== 1 && 
                            <div className="col-md-2 col-sm-5">
                            <button
                            onClick={() => handleRemoveClick(i)} 
                            className="mr10 btn btn-sm btn-danger">Remove</button>
                            </div>
                            }
                            {inputList.length - 1 === i && 
                            <div className="col-md-2 col-sm-5">
                            <button className="btn btn-sm btn-primary" onClick={handleAddClick}>Add</button>
                            </div>
                            }
                         </div>
                    </div>
                );
                })}
                </>
            ) : (addMembers === 2) ?
                <div className="row form-group">
                    <div className="col-md-3 col-sm-12">
                        <FileUpload
                            id={"addRwaImage"}
                            accept=".pdf,.png,.jpg,.jpeg,.doc"
                            documentUploadUrl={documentUploadUrl}
                            documentUrlData={documentUrlData}
                            onChange={(val) =>
                                saveImage(val)
                            }
                            // value={formData?.rwaImage}
                            prefilledFilename={formData?.rwaImage}
                            >
                            <span className="btn btn-transparent">
                                {localization.uploadCarnivalImage}
                            </span>
                        </FileUpload>
                    </div>
                </div>
            : null}
        </FormSection>*/}
        </>
        {/* ) : null} */}

    </FormSection>
  );
};

CarnivalForm.propTypes = {};

export default CarnivalForm;
